import { render, staticRenderFns } from "./page-agent-view.vue?vue&type=template&id=72991813&scoped=true&"
import script from "./page-agent-view.vue?vue&type=script&lang=js&"
export * from "./page-agent-view.vue?vue&type=script&lang=js&"
import style0 from "./page-agent-view.vue?vue&type=style&index=0&id=72991813&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72991813",
  null
  
)

export default component.exports